import { UseFormMethods } from "react-hook-form";
import { validateFiles } from "./fileSizeLimit";
import { SocItemDetailsAo } from "../../domain/SocItemDetailsAo";
import { SocSubmitStatus } from "../../domain/SocSubmitStatus";

const currencyPattern = /^\d{1,15}$|(?=^.{1,15}$)^\d+\.\d{0,2}$/;
const negativeCurrencyPattern = /^-?\d{1,15}$|(?=^.{1,15}$)^-?\d+\.\d{0,2}$/;

// Function to validate attachments
export const validateAttachments = async (
  attachments: { key: string; file: any }[],
  saveAction: SocSubmitStatus,
  aoItemDetails: UseFormMethods<SocItemDetailsAo>
): Promise<boolean> => {
  let hasError = false;
  attachments.forEach(({ key, file }) => {
    const isNotValid = !validateFiles(file);
    if (saveAction === SocSubmitStatus.Save) {
      if (isNotValid) {
        aoItemDetails.setError(key as keyof SocItemDetailsAo, { type: 'validate' });
        hasError = true;
      } else {
        aoItemDetails.clearErrors(key as keyof SocItemDetailsAo);
      }
    }
  });
  return hasError;
};

// Function to validate currency fields based on whether they allow negative values or not
export const validateCurrencyFields = async (
  keys: (keyof SocItemDetailsAo)[],
  aoItemDetails: UseFormMethods<SocItemDetailsAo>,
  isNegative?: boolean
): Promise<boolean> => {
  let hasError = false;
  const pattern = isNegative ? negativeCurrencyPattern : currencyPattern;
  keys.forEach(key => {
    const value = aoItemDetails.getValues()[key];
    if (value !== null) {
      const stringValue = value!.toString();
      const isValid = pattern.test(stringValue);
      if (!isValid) {
        aoItemDetails.setError(key, {
          type: 'pattern',
          message: 'Value does not match the format of currency',
        });
        hasError = true;
      } else {
        aoItemDetails.clearErrors(key);
      }
    }
  });
  return hasError;
};